// removed by extract-text-webpack-plugin
module.exports = {"root":"_1tGnBvO"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/Accessibility/ScreenReaderSkipTarget.less
 ** module id = 901
 ** module chunks = 0
 **/